import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IoToolbarComponent } from './io-toolbar/io-toolbar.component';
import { IoViewThumbnailComponent } from './views/io-view-thumbnail/io-view-thumbnail.component';
import { IoViewDetailComponent } from './views/io-view-detail/io-view-detail.component';
import { IoViewGalleryComponent } from './views/io-view-gallery/io-view-gallery.component';
import { IoViewPaneComponent } from './views/io-view-pane/io-view-pane.component';

import { NgxUploaderModule } from 'ngx-uploader';
import { NgxGalleryModule } from '@tdo-inc/tdo-gallery/projects/gallery/src';
import { DxDataGridModule } from 'devextreme-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { FileManagerViewModule } from '../../file-manager/file-manager-view/file-manager-view.module';
import { CategoryPipe } from './pipes/category.pipe';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { GeneralContextModule } from '../../tdo-shared/general-context/general-context.module';
import { IoFolderTreeComponent } from './io-folder-tree/io-folder-tree.component';
import { IoViewerComponent } from './io-viewer/io-viewer.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';

@NgModule({
    declarations: [
        IoToolbarComponent,
        IoViewThumbnailComponent,
        IoViewDetailComponent,
        IoViewGalleryComponent,
        IoViewPaneComponent,
        CategoryPipe,
        IoFolderTreeComponent,
        IoViewerComponent,
    ],
    imports: [
        CommonModule, DragDropModule,
        FormsModule, ReactiveFormsModule,
        FileManagerViewModule, GeneralContextModule,
        NgxUploaderModule, NgxGalleryModule,
        MatExpansionModule, MatTreeModule, MatProgressSpinnerModule,
        MatButtonModule, MatIconModule,
        LucideIconsModule, MatSelectModule,
        MatTooltipModule, MatSnackBarModule, MatFormFieldModule,
        DxDataGridModule, MatTabsModule, TdoControlsModule
    ],
    exports: [
        IoViewGalleryComponent,
        IoViewPaneComponent,
        IoViewDetailComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ImageOrganizerModule { }
